import { render, staticRenderFns } from "./trajectory.vue?vue&type=template&id=2f99f08a&scoped=true"
import script from "./trajectory.vue?vue&type=script&lang=js"
export * from "./trajectory.vue?vue&type=script&lang=js"
import style0 from "./trajectory.vue?vue&type=style&index=0&id=2f99f08a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99f08a",
  null
  
)

export default component.exports